// setovanje filtera npr. iz reduxa
export const handleSetFilter = (filterArr, table) => {
  if (table) {
    // Postavljanje filtera za svaku kolonu i ažuriranje polja u UI
    filterArr.forEach((filter) => {
      table.setHeaderFilterValue(filter.field, filter.value);
      if (typeof table.getColumn(filter.field).getElement === 'function') {
        // Ručno ažuriranje vrednosti u header polju
        const headerCell = table
          .getColumn(filter.field)
          .getElement()
          .querySelector('input, select');
        if (headerCell) {
          headerCell.value = filter.value; // Postavlja vrednost u UI
        }
      }
    });
  } else {
    console.error('Tabela nije inicijalizovana.');
  }
};
